import React from 'react';
import ReactDOM from 'react-dom';
import "antd/dist/antd.css"
import App from './App';
import Amplify from 'aws-amplify'
import { Provider } from "react-redux"
import * as serviceWorker from './serviceWorker';
import amplify_config from './util/Amplify'
import { store } from "./redux/store"

Amplify.configure(amplify_config);

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
